import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GalleryLayout1Component } from '@components/gallery/components/gallery-layout-1';
import { GalleryLayout10Component } from '@components/gallery/components/gallery-layout-10';
import { GalleryLayout11Component } from '@components/gallery/components/gallery-layout-11';
import { GalleryLayout12Component } from '@components/gallery/components/gallery-layout-12';
import { GalleryLayout13Component } from '@components/gallery/components/gallery-layout-13';
import { GalleryLayout14Component } from '@components/gallery/components/gallery-layout-14';
import { GalleryLayout15Component } from '@components/gallery/components/gallery-layout-15';
import { GalleryLayout16Component } from '@components/gallery/components/gallery-layout-16';
import { GalleryLayout2Component } from '@components/gallery/components/gallery-layout-2';
import { GalleryLayout3Component } from '@components/gallery/components/gallery-layout-3';
import { GalleryLayout4Component } from '@components/gallery/components/gallery-layout-4';
import { GalleryLayout5Component } from '@components/gallery/components/gallery-layout-5';
import { GalleryLayout6Component } from '@components/gallery/components/gallery-layout-6';
import { GalleryLayout7Component } from '@components/gallery/components/gallery-layout-7';
import { GalleryLayout8Component } from '@components/gallery/components/gallery-layout-8';
import { GalleryLayout9Component } from '@components/gallery/components/gallery-layout-9';
import { GalleryLayout } from '@components/gallery/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  imports: [
    GalleryLayout1Component,
    GalleryLayout3Component,
    GalleryLayout5Component,
    GalleryLayout6Component,
    GalleryLayout9Component,
    GalleryLayout10Component,
    GalleryLayout11Component,
    GalleryLayout12Component,
    GalleryLayout13Component,
    GalleryLayout8Component,
    GalleryLayout4Component,
    GalleryLayout2Component,
    GalleryLayout14Component,
    GalleryLayout7Component,
    GalleryLayout15Component,
    GalleryLayout16Component,
  ],
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryComponent extends ComponentLoaderAbstract<Layout<GalleryLayout>> {
  readonly layout = GalleryLayout;
}
